import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MainLayout from "../../../../layouts/MainLayout";
import PageHeader from "../../../../components/PageHeader";
import "../../../../assets/styles/custom-styles.css";
import useNotification from "../../../../hooks/useNotification";
import { detailsAddressFields } from "../../../../constants/forms/addressFields";
import DetailsSectionRenderer from "../../../../components/DetailsSectionRenderer";
import useBaseService from "../../../../hooks/services/useBaseService";
import { entities } from "../../../../constants/entities";
import useQueryWithLoader from "../../../../hooks/useQueryWithLoader";

const CustomerAddressDetailsPage = () => {
  const navigate = useNavigate();
  const { id, addressId } = useParams();
  const location = useLocation();
  const { showNotification } = useNotification();
  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate);

  const { data: addressData, isLoading: isLoadingAddress } = useQueryWithLoader(
    {
      queryKey: ["customerAddressDetails", id, addressId],
      queryFn: async () => {
        const response = await baseServiceGetByColumn(
          entities.customers.addresses.getById(id, addressId),
        );
        return response.result;
      },
      enabled: !!id && !!addressId,
      staleTime: 5 * 60 * 1000,
    },
  );

  useEffect(() => {
    if (location.state?.message) {
      showNotification(location.state.type, location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, showNotification, navigate, location.pathname]);
  const isPageLoading = isLoadingAddress;

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes do Endereço do Cliente"
        showBackButton={true}
        backUrl={`/aluguel/clientes/detalhes/${id}`}
      />
      <div className="container-fluid p-1">
        {addressData ? (
          <DetailsSectionRenderer
            sections={detailsAddressFields}
            formData={addressData}
            readOnly
          />
        ) : isPageLoading ? (
          <div className="text-center py-4">
            Carregando detalhes do endereço...
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            Não foi possível carregar os detalhes do endereço.
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default CustomerAddressDetailsPage;
